import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { TemplatesPage } from './features/templates/TemplatesPage';
import { TemplateDetailPage } from './features/templates/TemplateDetailPage';
import { TenantInspectorPage } from './features/tenants/TenantInspectorPage';
import { UsersPage } from './features/users/UsersPage';
import { TemplateGeneratorPage } from './features/cluvio/TemplateGeneratorPage';
import { DashboardCreatorPage } from './features/templates/DashboardCreatorPage';
import { GraphQLRunnerPage } from './features/graphql/GraphQLRunnerPage';
import { AuditPage } from './features/audit/AuditPage';
import { CluvioFiltersPage } from './features/cluvio/CluvioFiltersPage';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<TemplatesPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/:id" element={<TemplateDetailPage />} />
        <Route path="/tenants" element={<TenantInspectorPage />} />
        <Route path="/tenants/:id" element={<TenantInspectorPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:id" element={<UsersPage />} />
        <Route path="/generate" element={<TemplateGeneratorPage />} />
        <Route path="/create-dashboard" element={<DashboardCreatorPage />} />
        <Route path="/graphql" element={<GraphQLRunnerPage />} />
        <Route path="/filters" element={<CluvioFiltersPage />} />
        <Route path="/audit" element={<AuditPage />} />
      </Route>
    </Routes>
  );
}

export default App;
